'use client'

import type { MouseEvent } from 'react'
import { useState, useEffect, useRef, useCallback } from 'react'
import { CookieConsent } from '../../entities/landing/ui/CookieConsent'

interface PricingPlan {
    title: string
    sub: string
    price: string
    items: string[]
    btn: string
    href?: string
    featured?: boolean
    badge?: string
    suf?: string
    note?: string
}

const Logo = ({ className }: { className: string }) => {
    return (
        <div className={className}>
            <svg width='100' height='20' viewBox='0 0 100 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <path
                    d='M3.05284 14.4224C3.05284 14.5318 3.05284 14.6413 3.05284 14.7324C3.05284 16.0272 3.05284 17.3221 3.05284 18.6169C3.05284 18.6898 3.05284 18.7628 3.05284 18.8357C3.05284 18.9816 2.96681 19.0728 2.82918 19.091C2.72595 19.091 2.62272 19.091 2.5195 19.091C1.81411 19.091 1.10873 19.091 0.386145 19.091C0.0420553 19.091 0.00764643 19.0545 0.00764643 18.6716C0.00764643 15.3525 -0.00955803 12.0334 0.00764643 8.71431C0.00764643 7.69306 0.300122 6.74475 0.781847 5.86938C1.29798 4.93931 1.96896 4.17337 2.86359 3.62627C3.65499 3.13387 4.49801 2.78738 5.44426 2.73267C6.20125 2.67796 6.92384 2.7509 7.64643 2.98798C8.48944 3.27977 9.24644 3.71745 9.88301 4.35573C10.7088 5.17639 11.2938 6.14294 11.569 7.32832C11.7239 7.94837 11.8271 8.56842 11.7927 9.18847C11.7583 9.8997 11.6207 10.5927 11.3626 11.2492C11.0013 12.1793 10.468 12.9817 9.76258 13.62C9.02278 14.2948 8.17976 14.7871 7.19911 15.006C6.68298 15.1336 6.16684 15.1519 5.65071 15.1701C5.18619 15.1884 4.73887 15.0789 4.29156 14.9148C3.91306 14.7871 3.55177 14.6048 3.19047 14.4589C3.15606 14.4406 3.12165 14.4406 3.05284 14.4224ZM5.85716 11.9057C7.40556 11.9605 8.73031 10.5927 8.73031 8.96963C8.7131 7.20067 7.50879 5.94233 5.92598 5.92409C4.29156 5.90586 3.05284 7.25538 3.07004 8.91492C3.08724 10.6656 4.34317 11.9057 5.85716 11.9057Z'
                    fill='white'
                />
                <path
                    d='M23.3369 6.14307C23.4918 5.86952 23.6294 5.65068 23.767 5.4136C24.2143 4.64766 24.6617 3.89995 25.0918 3.13401C25.2294 2.89693 25.3843 2.80575 25.6423 2.82398C26.5197 2.84222 27.3972 2.82398 28.2746 2.82398C28.3262 2.82398 28.395 2.82398 28.4466 2.82398C28.6531 2.86046 28.6703 2.9334 28.5671 3.13401C27.8617 4.35587 27.1735 5.55949 26.4681 6.74488C26.124 7.34669 25.78 7.93027 25.4359 8.53208C25.7283 9.02447 26.0036 9.49863 26.2961 9.97278C27.0015 11.1399 27.7069 12.3253 28.4122 13.4925C28.6015 13.8207 28.7907 14.1308 28.98 14.459C29.1176 14.6779 29.066 14.8055 28.8251 14.8055C27.9305 14.8055 27.0531 14.8055 26.1585 14.8055C25.9864 14.8055 25.8832 14.7326 25.7972 14.5684C25.0746 13.3466 24.3348 12.1247 23.595 10.9029C23.5262 10.7752 23.4574 10.6475 23.3541 10.4834C23.1821 10.7752 23.0272 11.0305 22.8724 11.2858C22.2186 12.3618 21.5649 13.4378 20.9283 14.532C20.8079 14.7326 20.6702 14.8238 20.4466 14.8238C19.6036 14.8055 18.7605 14.8238 17.9175 14.8238C17.8831 14.8238 17.8487 14.8238 17.7971 14.8238C17.6078 14.8055 17.5562 14.7143 17.6594 14.532C17.7455 14.3861 17.8315 14.2402 17.9175 14.1125C18.5713 13.0183 19.2423 11.9423 19.896 10.8481C20.3089 10.1734 20.7046 9.48039 21.1175 8.7874C21.2208 8.62326 21.2208 8.49561 21.1175 8.33148C20.1197 6.63546 19.139 4.93944 18.1584 3.24343C18.1412 3.22519 18.1412 3.20695 18.124 3.18872C17.9863 2.9334 18.0207 2.86046 18.3132 2.86046C19.2423 2.86046 20.1713 2.86046 21.1003 2.86046C21.3412 2.86046 21.4788 2.95164 21.5993 3.17048C22.1154 4.08232 22.6487 4.99415 23.1821 5.90599C23.2165 5.9607 23.2681 6.03365 23.3369 6.14307Z'
                    fill='white'
                />
                <path
                    d='M13.2895 8.60481C13.2895 6.78114 13.2895 4.95747 13.2895 3.13379C13.2895 3.06085 13.2895 2.96966 13.2895 2.89671C13.2895 2.6414 13.3239 2.60493 13.582 2.60493C14.2358 2.60493 14.9067 2.60493 15.5605 2.60493C15.7153 2.60493 15.8874 2.60493 16.0422 2.60493C16.2315 2.60493 16.2487 2.6414 16.2659 2.82377C16.2659 3.00614 16.2659 3.20674 16.2659 3.38911C16.2659 6.94527 16.2659 10.5197 16.2659 14.0758C16.2659 14.6229 16.2831 14.6047 15.767 14.6047C15.0788 14.6047 14.3906 14.6047 13.7024 14.6047C13.6164 14.6047 13.5132 14.6047 13.4272 14.5865C13.3239 14.5682 13.2723 14.4953 13.2895 14.3676C13.3067 13.0363 13.3067 11.7051 13.3067 10.3738C13.2895 9.7902 13.2895 9.18839 13.2895 8.60481Z'
                    fill='white'
                />
                <path
                    d='M52.4467 8.82404C52.4467 5.52319 55.0446 2.66002 58.3651 2.67826C61.4791 2.69649 64.163 5.45024 64.1458 8.93346C64.1286 12.3802 61.4963 15.0975 58.279 15.0975C55.079 15.0975 52.4295 12.3437 52.4467 8.82404ZM61.1006 8.91522C61.135 7.16449 59.7758 5.86968 58.2618 5.90616C56.593 5.94263 55.3887 7.43804 55.4747 9.06111C55.578 10.6477 56.8339 11.9972 58.5027 11.8696C59.8791 11.7601 61.1522 10.5201 61.1006 8.91522Z'
                    fill='white'
                />
                <path
                    d='M65.1782 11.4316C65.1782 10.5562 65.1954 9.68084 65.1782 8.82371C65.161 7.89364 65.3675 7.01828 65.7288 6.17939C66.2105 5.10342 66.9503 4.28277 67.8793 3.60801C68.5331 3.15209 69.2557 2.91501 70.0127 2.75088C70.4256 2.6597 70.8557 2.6597 71.2858 2.67793C71.9224 2.71441 72.5073 2.87854 73.0923 3.09738C73.5568 3.27975 74.0041 3.53506 74.3998 3.88156C75.1052 4.48337 75.7074 5.17637 76.1031 6.05173C76.3611 6.6353 76.5504 7.23712 76.6536 7.8754C76.7396 8.40427 76.7396 8.9149 76.7396 9.42552C76.7396 11.1033 76.7396 12.7993 76.7396 14.4771C76.7396 14.9513 76.7224 14.9513 76.2751 14.9513C75.5353 14.9513 74.7783 14.9513 74.0385 14.9513C73.7117 14.9513 73.6945 14.933 73.6945 14.5683C73.6945 13.1823 73.6945 11.7963 73.6945 10.4103C73.6945 9.91792 73.7117 9.42552 73.6945 8.93313C73.6772 8.40427 73.5912 7.89364 73.3676 7.43772C72.903 6.52588 72.1977 5.97878 71.1826 5.92407C70.8041 5.90583 70.4428 5.90583 70.0987 6.05173C69.8579 6.14291 69.6342 6.25233 69.4277 6.41646C68.9116 6.79943 68.5331 7.29183 68.3611 7.96659C68.2923 8.24014 68.2578 8.49545 68.2578 8.769C68.2578 10.6656 68.2578 12.5622 68.2578 14.4589C68.2578 14.55 68.2578 14.6595 68.2578 14.7507C68.2406 14.8965 68.1718 14.9513 68.0342 14.9513C67.5008 14.9513 66.9847 14.9513 66.4514 14.9695C66.1417 14.9695 65.8492 14.9695 65.5395 14.9695C65.2643 14.9695 65.2127 14.9148 65.2127 14.623C65.1782 13.5653 65.1782 12.5075 65.1782 11.4316Z'
                    fill='white'
                />
                <path
                    d='M40.9715 11.1402C40.9715 10.1554 40.9715 9.17066 40.9715 8.20411C40.9715 7.82114 40.9715 7.43817 41.0576 7.07343C41.2124 6.41691 41.4189 5.77863 41.7802 5.19505C42.3651 4.2285 43.1737 3.55374 44.1544 3.09783C44.7049 2.84251 45.2899 2.69662 45.9092 2.71485C46.0985 2.71485 46.1673 2.7878 46.1673 2.98841C46.1673 3.24372 46.1673 3.4808 46.1673 3.73611C46.1673 4.35616 46.1673 4.95797 46.1673 5.57802C46.1673 5.86981 46.1157 5.92452 45.8404 5.96099C44.8942 6.08865 44.3264 6.67223 44.0856 7.51112C43.9995 7.78467 44.0167 8.09469 44.0167 8.36824C44.0167 10.3925 44.0167 12.435 44.0167 14.4593C44.0167 14.897 44.0167 14.897 43.6038 14.897C42.864 14.897 42.107 14.897 41.3673 14.897C40.9543 14.897 40.9543 14.897 40.9543 14.4593C40.9716 13.3286 40.9715 12.2344 40.9715 11.1402Z'
                    fill='white'
                />
                <path
                    d='M51.3457 8.60513C51.3457 10.447 51.3457 12.2889 51.3457 14.1309C51.3457 14.605 51.3285 14.6233 50.8812 14.6233C50.1758 14.6233 49.4877 14.6233 48.7823 14.6233C48.7135 14.6233 48.6274 14.6233 48.5586 14.6233C48.421 14.605 48.335 14.5503 48.335 14.3862C48.335 14.3315 48.335 14.2585 48.335 14.2038C48.335 10.4835 48.335 6.74498 48.335 3.02469C48.335 2.96998 48.335 2.93351 48.335 2.8788C48.3522 2.67819 48.3866 2.62348 48.5758 2.62348C48.7479 2.62348 48.9199 2.62348 49.092 2.62348C49.7285 2.62348 50.3823 2.62348 51.0189 2.62348C51.3457 2.62348 51.3457 2.62348 51.3457 2.96998C51.3457 4.83013 51.3457 6.72675 51.3457 8.60513Z'
                    fill='white'
                />
                <path
                    d='M100 8.87857C100 10.7205 100 12.5624 100 14.4043C100 14.8785 99.9828 14.8967 99.5355 14.8967C98.8301 14.8967 98.142 14.8967 97.4366 14.8967C97.3678 14.8967 97.2817 14.8967 97.2129 14.8967C97.0753 14.8785 96.9893 14.8237 96.9893 14.6596C96.9893 14.6049 96.9893 14.532 96.9893 14.4772C96.9893 10.757 96.9893 7.01842 96.9893 3.29813C96.9893 3.24342 96.9893 3.20694 96.9893 3.15223C97.0065 2.95163 97.0409 2.89692 97.2301 2.89692C97.4022 2.89692 97.5742 2.89692 97.7463 2.89692C98.3828 2.89692 99.0366 2.89692 99.6732 2.89692C100 2.89692 100 2.89692 100 3.24342C100 5.1218 100 7.00018 100 8.87857Z'
                    fill='white'
                />
                <path
                    d='M94.7699 8.71427C94.7699 6.83589 94.7699 4.95751 94.7699 3.06089C94.7699 2.71439 94.7526 2.71439 94.443 2.71439C93.8064 2.71439 93.1526 2.71439 92.5161 2.71439C92.344 2.71439 92.172 2.71439 91.9999 2.71439C91.8107 2.73263 91.7763 2.7691 91.7591 2.9697C91.7591 3.02441 91.7591 3.06089 91.7591 3.1156C91.7591 3.49857 91.7591 3.8633 91.7591 4.24627C90.7268 3.29796 89.4193 2.71439 87.9913 2.71439C84.6708 2.69615 82.073 5.55932 82.073 8.86017C82.0558 12.3981 84.7052 15.1336 87.9225 15.1336C89.3849 15.1336 90.7268 14.5683 91.7591 13.62C91.7591 13.8388 91.7591 14.0759 91.7591 14.2947C91.7591 14.3494 91.7591 14.4224 91.7591 14.4771C91.7591 14.6412 91.8451 14.7142 91.9827 14.7142C92.0515 14.7142 92.1376 14.7142 92.2064 14.7142C92.9118 14.7142 93.5999 14.7142 94.3053 14.7142C94.7526 14.7142 94.7699 14.7142 94.7699 14.2218C94.7699 12.3981 94.7699 10.5562 94.7699 8.71427ZM88.1289 11.9057C86.4601 12.0151 85.2042 10.6838 85.1009 9.09725C84.9977 7.47418 86.202 5.97876 87.8881 5.94229C89.4021 5.90582 90.7612 7.20062 90.7268 8.95135C90.7956 10.5562 89.5225 11.7963 88.1289 11.9057Z'
                    fill='white'
                />
                <path
                    d='M79.9223 14.9695C81.0625 14.9695 81.9869 13.9898 81.9869 12.7811C81.9869 11.5725 81.0625 10.5927 79.9223 10.5927C78.7821 10.5927 77.8578 11.5725 77.8578 12.7811C77.8578 13.9898 78.7821 14.9695 79.9223 14.9695Z'
                    fill='white'
                />
                <path
                    d='M37.1349 8.91513C37.1177 9.77226 36.808 10.5382 36.1714 11.1218C35.7757 11.4865 35.3284 11.6871 34.8467 11.8148C34.6746 11.8512 34.4854 11.8512 34.3134 11.8695C33.1607 11.8148 32.3004 11.2677 31.7843 10.1552C31.5262 9.60813 31.4574 8.98808 31.5606 8.36803C31.7327 7.12793 32.4725 6.39846 33.5047 5.97902C33.694 5.90607 33.9004 5.88783 34.0897 5.88783V2.67817C30.9585 2.80583 28.5154 5.46839 28.4466 8.69629C28.3778 12.3072 31.0101 15.0609 34.2789 15.1156C37.5134 15.0791 40.0941 12.4166 40.1629 9.06103C40.1629 9.02455 40.1629 8.96984 40.1629 8.93337H37.1349V8.91513Z'
                    fill='white'
                />
                <path
                    d='M38.5971 5.77833C38.7004 5.48655 38.9068 5.26771 39.1649 5.17652L41.1606 4.41058L39.1821 3.64464C38.9068 3.53522 38.7004 3.31638 38.6143 3.04282L37.8746 0.909126L37.152 3.02459C37.0487 3.31638 36.8423 3.53522 36.5842 3.6264L34.5885 4.39234L36.5842 5.15829C36.8595 5.26771 37.0659 5.48655 37.152 5.7601L37.8746 7.87556L38.5971 5.77833Z'
                    fill='white'
                />
            </svg>
        </div>
    )
}

const SHOWCASE_IMAGES = {
    audit: [
        '/assets/images/audit_1.jpg',
        '/assets/images/audit_2.jpg',
        '/assets/images/audit_3.jpg',
        '/assets/images/audit_4.jpg',
    ],
    shirt: [
        '/assets/images/shirt_1.jpg',
        '/assets/images/shirt_2.jpg',
        '/assets/images/shirt_3.jpg',
        '/assets/images/shirt_4.jpg',
    ],
    shampoo: [
        '/assets/images/shampoo_1.jpg',
        '/assets/images/shampoo_2.jpg',
        '/assets/images/shampoo_3.jpg',
        '/assets/images/shampoo_4.jpg',
    ],
    case: [
        '/assets/images/case_1.jpg',
        '/assets/images/case_2.jpg',
        '/assets/images/case_3.jpg',
        '/assets/images/case_4.jpg',
    ],
    text: [
        '/assets/images/text_1.jpg',
        '/assets/images/text_2.jpg',
        '/assets/images/text_3.jpg',
        '/assets/images/text_4.jpg',
    ],
}

const FAQS = [
    {
        q: 'Pixorion.AI – это российский сервис?',
        a: 'Да, Pixorion.AI – это российский сервис для анализа и генерации изображений для карточек товаров на маркетплейсах. Нет рисков санкций или блокировок. Оплата российской картой, поддержка на русском языке.',
    },
    {
        q: 'Для каких маркетплейсов можно создать карточки?',
        a: 'Wildberries и OZON. Если нужна поддержка другого маркетплейса, напишите на support@pixorion.ai',
    },
    {
        q: 'Как начать работать бесплатно?',
        a: 'При регистрации вы получаете 250 бесплатных токенов для доступа ко всем возможностям: анализ карточек, генерация изображений и SEO-описаний.',
    },
    {
        q: 'Что под капотом у Pixorion.AI?',
        a: 'Комплексное решение на базе ИИ — интегрированная кастомная платформа для селлеров на основе передовых технологий, бенчмарков и лучших практик российских маркетплейсов.',
    },
    {
        q: 'Как можно купить токены?',
        a: 'Картой российского банка, через СБП и другие платёжные системы. Все платежи безопасны и без комиссий.',
    },
]

const BENEFITS = [
    'Анализ карточек на Wildberries и OZON за 1 минуту',
    'Создание продающего заголовка и SEO-описания товара',
    'Генерация новых фото на основе аналитики',
    'Комплект картинок для карточки товара в один клик',
]

export const Landing = () => {
    const [menuOpen, setMenuOpen] = useState(false)
    const [activeTab, setActiveTab] = useState('images')
    const [activeSub, setActiveSub] = useState('shirt')
    const [activeBenefit, setActiveBenefit] = useState(0)
    const [isTabRotationPaused, setIsTabRotationPaused] = useState(false)
    const [openFaq, setOpenFaq] = useState<number | null>(null)
    const [lightboxImage, setLightboxImage] = useState<string | null>(null)
    const [isYandexPopupOpen, setIsYandexPopupOpen] = useState(false)
    const benefitTimerRef = useRef<NodeJS.Timeout | null>(null)
    const imageTimerRef = useRef<NodeJS.Timeout | null>(null)
    const showcaseTabsRef = useRef<HTMLDivElement | null>(null)
    const showcasePanelRef = useRef<HTMLDivElement | null>(null)

    const getImages = useCallback(() => {
        if (activeTab === 'audit') return SHOWCASE_IMAGES.audit
        if (activeTab === 'text') return SHOWCASE_IMAGES.text
        return SHOWCASE_IMAGES[activeSub as keyof typeof SHOWCASE_IMAGES] || []
    }, [activeTab, activeSub])

    useEffect(() => {
        benefitTimerRef.current = setInterval(() => {
            setActiveBenefit(prev => (prev + 1) % BENEFITS.length)
        }, 3000)
        return () => clearInterval(benefitTimerRef.current!)
    }, [])

    useEffect(() => {
        if (isTabRotationPaused) {
            clearInterval(imageTimerRef.current!)
            return
        }
        const tabs = ['audit', 'images', 'text']
        imageTimerRef.current = setInterval(() => {
            setActiveTab(prev => tabs[(tabs.indexOf(prev) + 1) % tabs.length])
        }, 4000)
        return () => clearInterval(imageTimerRef.current!)
    }, [isTabRotationPaused])

    useEffect(() => {
        const handleScroll = () => {
            const header = document.querySelector('.header')
            if (window.scrollY > 20) {
                header?.classList.add('scrolled')
            } else {
                header?.classList.remove('scrolled')
            }
        }
        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    const displayedImages = getImages().slice(0, 4)

    const captions = {
        audit: 'Вставьте ссылку на карточку → получите полный отчёт с оценками и рекомендациями',
        images: 'Загрузите фото товара → выберите стиль → получите готовый визуал за секунды',
        text: 'Задайте параметры → получите SEO-оптимизированное название и описание',
    }

    const handleShowcaseInteraction = () => {
        setIsTabRotationPaused(true)
    }

    const handleShowcaseMouseLeave = (event: MouseEvent<HTMLDivElement>) => {
        const nextTarget = event.relatedTarget

        if (
            nextTarget instanceof Node &&
            (showcaseTabsRef.current?.contains(nextTarget) || showcasePanelRef.current?.contains(nextTarget))
        ) {
            return
        }

        setIsTabRotationPaused(false)
    }

    return (
        <div style={{ background: '#0d0a12', color: '#fff', fontFamily: 'Inter, sans-serif', overflowX: 'hidden' }}>
            <style>{`
        * { margin: 0; padding: 0; box-sizing: border-box; }
        html { scroll-behavior: smooth; }
        @keyframes shimmer { 0% { background-position: 200% 0; } 100% { background-position: -200% 0; } }
        .header { position: fixed; top: 12px; left: 50%; transform: translateX(-50%); width: calc(100% - 24px); max-width: 960px; z-index: 50; border-radius: 16px; transition: all 0.4s ease; padding: 12px 20px; display: flex; align-items: center; justify-content: space-between; }
        .logo-header { height: 24px; width: auto; }
        .logo-header svg { height: 24px !important; width: auto !important; }
        .logo-footer { height: 32px; width: auto; }
        .logo-footer svg { height: 32px !important; width: auto !important; }
        .header.scrolled { background: rgba(13,10,18,0.85); backdrop-filter: blur(20px); border: 1px solid rgba(255,255,255,0.1); }
        .hero { position: relative; padding: 140px 16px 80px; }
        .hero-bg { position: absolute; inset: 0; background: radial-gradient(ellipse at top, rgba(118,65,226,0.15), transparent 70%); }
        .hero-inner { max-width: 1200px; margin: 0 auto; text-align: center; position: relative; z-index: 1; }
        .hero-badge { display: inline-flex; align-items: center; gap: 8px; padding: 9px 18px; border-radius: 999px; background: rgba(118,65,226,0.1); border: 1px solid rgba(118,65,226,0.2); font-size: 14px; color: #d3b1ff; margin-bottom: 32px; }
        .hero h1 { font-size: clamp(28px, 5.5vw, 72px); font-weight: 500; line-height: 1.1; margin-bottom: 40px; }
        .shimmer { background: linear-gradient(90deg, #7641e2 0%, #a855f7 25%, #ec4899 50%, #a855f7 75%, #7641e2 100%); background-size: 200% auto; -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; animation: shimmer 3s linear infinite; }
        .benefits { min-height: 110px; margin: 8px auto 48px; position: relative; max-width: 800px; }
        .benefit { position: absolute; inset: 0; display: flex; align-items: center; justify-content: center; opacity: 0; transform: translateY(10px); transition: all 0.5s ease; }
        .benefit.active { opacity: 1; transform: translateY(0); }
        .benefit span { color: rgba(255,255,255,0.9); font-size: clamp(18px, 3vw, 28px); font-weight: 500; }
        .benefit-dots { position: absolute; bottom: -20px; left: 50%; transform: translateX(-50%); display: flex; gap: 8px; }
        .benefit-dots button { width: 7px; height: 7px; border-radius: 999px; background: rgba(255,255,255,0.2); padding: 0; border: none; cursor: pointer; }
        .benefit-dots button.active { width: 22px; background: linear-gradient(to right, #7641e2, #a855f7); }
        .cta-main { padding: clamp(14px, 2vw, 18px) clamp(28px, 4vw, 40px); border-radius: 16px; background: linear-gradient(to right, #7641e2, #a855f7); color: white; font-weight: 500; display: inline-flex; align-items: center; gap: 8px; font-size: clamp(15px, 1.8vw, 18px); text-decoration: none; border: none; cursor: pointer; }
        .cta-sub { margin-top: 20px; font-size: 14px; color: #6b6572; display: flex; align-items: center; justify-content: center; gap: 8px; }
        .cta-sub strong { color: #d3b1ff; }
        .section { padding: clamp(60px, 10vw, 120px) 0; }
        .container { max-width: 1100px; margin: 0 auto; padding: 0 clamp(16px, 4vw, 24px); }
        .section-head { text-align: center; margin-bottom: clamp(40px, 6vw, 80px); }
        .section-head h2 { font-size: clamp(28px, 4vw, 48px); margin-bottom: 16px; }
        .section-head p { color: #a8a3ae; font-size: clamp(18px, 2vw, 22px); }
        .showcase-tabs { display: flex; justify-content: center; flex-wrap: wrap; gap: 8px; margin-bottom: 40px; }
        .tab { padding: 10px 24px; border-radius: 12px; background: rgba(255,255,255,0.03); color: #a8a3ae; font-size: 14px; font-weight: 500; cursor: pointer; border: none; }
        .tab.active { background: rgba(118,65,226,0.2); color: #d3b1ff; border: 1px solid rgba(118,65,226,0.3); }
        .showcase-panel { padding: clamp(16px, 2vw, 24px); border-radius: 24px; background: linear-gradient(135deg, rgba(255,255,255,0.04), rgba(255,255,255,0.01)); border: 1px solid rgba(255,255,255,0.08); }
        .subtabs { display: flex; justify-content: center; gap: 8px; margin-bottom: 24px; flex-wrap: wrap; }
        .subtab { padding: 8px 20px; border-radius: 20px; background: rgba(255,255,255,0.07); color: rgba(255,255,255,0.55); font-size: 14px; font-weight: 500; border: 1px solid rgba(255,255,255,0.10); cursor: pointer; }
        .subtab.active { background: linear-gradient(to right, #7641e2, #a855f7); color: white; border-color: transparent; }
        .product-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; margin-bottom: 20px; }
        @media (max-width: 600px) { .product-grid { grid-template-columns: repeat(2, 1fr); } }
        .product-grid img { width: 100%; aspect-ratio: 3/4; object-fit: cover; border-radius: 16px; border: 1px solid rgba(255,255,255,0.06); cursor: zoom-in; display: block; }
        .showcase-caption { text-align: center; color: #6b6572; font-size: 14px; }
        #lightbox { display: none; position: fixed; inset: 0; z-index: 9999; background: rgba(0,0,0,0.92); align-items: center; justify-content: center; backdrop-filter: blur(8px); }
        #lightbox.open { display: flex; }
        #lightbox img { max-width: 92vw; max-height: 92vh; object-fit: contain; border-radius: 12px; }
        .yandex-popup { position: fixed; inset: 0; z-index: 10000; background: rgba(0,0,0,0.82); backdrop-filter: blur(6px); display: flex; align-items: center; justify-content: center; padding: 20px; }
        .yandex-popup-modal { width: min(720px, 96vw); background: #0d0a12; border: 1px solid rgba(118,65,226,0.5); border-radius: 16px; padding: 16px; position: relative; }
        .yandex-popup-close { position: absolute; top: 8px; right: 10px; width: 32px; height: 32px; border-radius: 999px; border: 1px solid rgba(255,255,255,0.2); background: rgba(255,255,255,0.05); color: #fff; font-size: 20px; line-height: 1; cursor: pointer; }
        .yandex-popup iframe { width: 100%; height: min(78vh, 760px); border: 2px solid white; border-radius: 0.75rem; background-color: transparent; }
        .features-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; }
        .feature-card { padding: clamp(24px, 3vw, 36px); border-radius: 24px; background: linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02)); border: 1px solid rgba(255,255,255,0.08); }
        .feature-icon { width: 56px; height: 56px; border-radius: 16px; background: linear-gradient(135deg, #7641e2, #a855f7); display: flex; align-items: center; justify-content: center; color: white; margin-bottom: 20px; font-size: 24px; }
        .feature-card h3 { font-size: 20px; margin-bottom: 8px; }
        .feature-card .sub { color: #6b6572; font-size: 14px; margin-bottom: 16px; }
        .feature-card p { color: #b8b3bd; font-size: 17px; margin-bottom: 18px; }
        .feature-card ul { list-style: none; }
        .feature-card ul li { display: flex; align-items: center; gap: 10px; color: #b8b3bd; font-size: 16px; padding: 6px 0; }
        .cta-banner { margin: 60px 0; padding: clamp(40px, 6vw, 64px) clamp(24px, 4vw, 48px); border-radius: 28px; background: linear-gradient(135deg, #7641e2 0%, #a855f7 100%); text-align: center; position: relative; overflow: hidden; }
        .cta-banner h2 { color: white; font-size: clamp(24px, 4vw, 40px); margin-bottom: 16px; }
        .cta-banner p { color: rgba(255,255,255,0.9); font-size: 20px; margin-bottom: 28px; line-height: 1.5; }
        .cta-banner .btn { background: white; color: #7641e2; padding: 15px 34px; border-radius: 14px; font-weight: 600; font-size: 16px; display: inline-flex; align-items: center; gap: 8px; box-shadow: 0 8px 32px rgba(0,0,0,0.3); cursor: pointer; text-decoration: none; border: none; }
        .whyus-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; }
        .whyus-card { padding: clamp(24px, 3vw, 36px); border-radius: 24px; border: 1px solid rgba(255,255,255,0.08); }
        .whyus-card.minus { background: linear-gradient(135deg, rgba(255,255,255,0.03), rgba(255,255,255,0.01)); }
        .whyus-card.plus { background: linear-gradient(135deg, rgba(118,65,226,0.1), rgba(21,14,30,0.3)); border: 1px solid rgba(118,65,226,0.2); }
        .whyus-card h4 { font-size: 11px; text-transform: uppercase; letter-spacing: 0.1em; margin-bottom: 20px; font-weight: 500; }
        .whyus-card.minus h4 { color: rgba(248,113,113,0.7); }
        .whyus-card.plus h4 { color: #d3b1ff; }
        .whyus-card ul { list-style: none; }
        .whyus-card ul li { display: flex; align-items: center; gap: 12px; padding: 8px 0; font-size: 16px; }
        .whyus-card.minus ul li { color: #8a8490; }
        .whyus-card.plus ul li { color: rgba(255,255,255,0.9); font-weight: 500; }
        .item-icon { width: 28px; height: 28px; border-radius: 8px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; font-size: 14px; font-weight: bold; }
        .whyus-card.minus .item-icon { background: rgba(239,68,68,0.08); color: rgba(248,113,113,0.6); }
        .whyus-card.plus .item-icon { background: rgba(118,65,226,0.2); color: #a855f7; }
        .forwhom-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 20px; }
        @media (max-width: 600px) { .forwhom-grid { grid-template-columns: 1fr; } }
        .forwhom-card { padding: clamp(24px, 3vw, 40px); border-radius: 24px; background: linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02)); border: 1px solid rgba(255,255,255,0.08); text-align: center; }
        .forwhom-card .ico { width: 64px; height: 64px; border-radius: 18px; display: flex; align-items: center; justify-content: center; margin: 0 auto 22px; background: linear-gradient(135deg, #7641e2, #a855f7); color: white; font-size: 32px; }
        .forwhom-card .ico svg { width: 36px; height: 36px; color: white; }
        .forwhom-card h3 { color: white; font-size: 20px; margin-bottom: 12px; }
        .forwhom-card p { color: #b8b3bd; font-size: 17px; }
        .pricing-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(300px, 1fr)); gap: 20px; max-width: 1000px; margin: 0 auto; }
        .media-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(280px, 1fr)); gap: 20px; }
        .media-card { padding: 24px; border-radius: 16px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.08); transition: all 0.3s; display: block; text-decoration: none; }
        .media-card:hover { border-color: rgba(118,65,226,0.3); transform: translateY(-2px); }
        .media-logo { height: 32px; margin-bottom: 16px; display: flex; align-items: center; }
        .media-card p { color: white; font-size: 15px; font-weight: 500; line-height: 1.55; margin-bottom: 16px; }
        .media-link { color: #a855f7; font-size: 14px; display: inline-flex; align-items: center; gap: 6px; }
        
        .price-card { padding: clamp(24px, 3vw, 32px) clamp(20px, 2.5vw, 28px); border-radius: 24px; background: linear-gradient(135deg, rgba(255,255,255,0.06), rgba(255,255,255,0.02)); border: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; position: relative; }
        .price-card.featured { background: linear-gradient(to bottom, rgba(118,65,226,0.15), #0d0a12); border: 2px solid rgba(118,65,226,0.5); box-shadow: 0 0 60px rgba(118,65,226,0.15); }
        .price-badge { position: absolute; top: -1px; left: 50%; transform: translateX(-50%); background: linear-gradient(to right, #7641e2, #a855f7); color: white; font-size: 11px; font-weight: 500; padding: 5px 14px; border-radius: 0 0 10px 10px; }
        .price-card h3 { color: white; font-size: 20px; margin-bottom: 6px; }
        .price-card .plan-sub { color: #6b6572; font-size: 14px; margin-bottom: 20px; }
        .price-value { margin-bottom: 20px; }
        .price-value .num { color: white; font-size: 24px; font-weight: 700; }
        .price-value .suf { color: #6b6572; font-size: 14px; margin-left: 4px; }
        .price-card ul { list-style: none; flex: 1; margin-bottom: 20px; }
        .price-card ul li { display: flex; align-items: center; gap: 10px; color: #b8b3bd; font-size: 15px; }
        .check-ico { width: 18px; height: 18px; border-radius: 50%; background: rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: center; color: rgba(255,255,255,0.4); font-size: 11px; flex-shrink: 0; }
        .price-card.featured .check-ico { background: rgba(118,65,226,0.2); color: #a855f7; }
        .price-btn { width: 100%; display: block; padding: 13px; border-radius: 12px; font-weight: 500; font-size: 15px; cursor: pointer; border: none; text-align: center; }
        .price-card .price-btn { background: rgba(255,255,255,0.05); color: white; border: 2px solid rgba(118,65,226,0.5); }
        .price-card.featured .price-btn { background: linear-gradient(to right, #7641e2, #a855f7); color: white; border: none; }
        .faq-wrap { max-width: 720px; margin: 0 auto; }
        .faq-item { margin-bottom: 12px; border-radius: 16px; background: rgba(255,255,255,0.03); border: 1px solid rgba(255,255,255,0.06); overflow: hidden; transition: all 0.3s; }
        .faq-item.open { background: linear-gradient(135deg, rgba(118,65,226,0.1), transparent); border-color: rgba(118,65,226,0.2); }
        .faq-q { width: 100%; padding: 22px 26px; display: flex; align-items: center; justify-content: space-between; color: white; font-size: 16px; font-weight: 500; text-align: left; gap: 16px; cursor: pointer; border: none; background: none; }
        .faq-q .chev { width: 20px; height: 20px; color: rgba(255,255,255,0.3); transition: transform 0.2s, color 0.2s; flex-shrink: 0; }
        .faq-item.open .chev { transform: rotate(180deg); color: #a855f7; }
        .faq-a { padding: 0 26px 22px; color: #a8a3ae; line-height: 1.65; font-size: 16px; display: none; }
        .faq-item.open .faq-a { display: block; }
        .final-cta { max-width: 800px; margin: 0 auto; padding: clamp(48px, 6vw, 80px) clamp(24px, 4vw, 48px); border-radius: 28px; background: linear-gradient(135deg, rgba(118,65,226,0.2), #1a0f25, #0d0a12); border: 1px solid rgba(118,65,226,0.2); text-align: center; position: relative; overflow: hidden; }
        .final-cta .spark { font-size: 28px; color: #7641e2; margin-bottom: 24px; display: block; }
        .final-cta h2 { font-size: clamp(24px, 4vw, 40px); margin-bottom: 16px; }
        .final-cta p { color: #b8b3bd; font-size: clamp(16px, 1.8vw, 20px); margin-bottom: 32px; line-height: 1.6; }
        footer { padding: clamp(40px, 6vw, 64px) 0 24px; border-top: 1px solid rgba(255,255,255,0.06); margin-top: 40px; }
        .footer-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(180px, 1fr)); gap: 32px; margin-bottom: 32px; }
        .footer-col h5 { color: rgba(255,255,255,0.9); font-size: 13px; font-weight: 600; margin-bottom: 14px; font-family: Inter, sans-serif; }
        .footer-col p { color: #b8b3bd; font-size: 14px; line-height: 1.55; }
        .footer-col a { color: #b8b3bd; font-size: 15px; display: flex; align-items: center; gap: 8px; padding: 5px 0; transition: color 0.2s; text-decoration: none; }
        .footer-col a:hover { color: white; }
        .footer-bottom { padding-top: 24px; border-top: 1px solid rgba(255,255,255,0.05); display: flex; flex-direction: column; align-items: center; gap: 12px; }
        .footer-bottom nav { display: flex; flex-wrap: wrap; justify-content: center; gap: 24px; }
        .footer-bottom nav a { color: #6b6572; font-size: 13px; text-decoration: none; }
        .footer-bottom .copy { color: #6b6572; font-size: 12px; }
        .nav { display: flex; align-items: center; gap: 4px; }
        .nav a { color: #a8a3ae; padding: 8px 16px; border-radius: 8px; font-size: 15px; transition: all 0.2s; text-decoration: none; }
        .nav a:hover { color: #fff; background: rgba(255,255,255,0.05); }
        .btn-primary { padding: 9px 22px; border-radius: 12px; background: linear-gradient(to right, #7641e2, #a855f7); color: white; font-weight: 500; font-size: 15px; transition: transform 0.2s, box-shadow 0.2s; cursor: pointer; text-decoration: none; border: none; display: inline-flex; align-items: center; }
        .btn-primary:hover { transform: translateY(-1px); box-shadow: 0 8px 25px rgba(118,65,226,0.4); }
        .header-right { display: flex; align-items: center; gap: 12px; }
        .menu-btn { display: none; color: rgba(255,255,255,0.7); padding: 4px; cursor: pointer; width: 24px; height: 24px; }
        .logo-link { display: inline-flex; align-items: center; gap: 10px; color: #fff; transition: opacity 0.2s; text-decoration: none; }
        .logo-link:hover { opacity: 0.8; }
        @media (max-width: 768px) {
          .nav { display: none; }
          .menu-btn { display: block; }
          .nav.open { display: flex; flex-direction: column; position: absolute; top: 100%; left: 0; right: 0; background: rgba(13,10,18,0.95); backdrop-filter: blur(20px); border-radius: 0 0 16px 16px; padding: 12px; margin-top: 8px; border: 1px solid rgba(255,255,255,0.1); }
          .nav.open a { padding: 12px 16px; }
          .footer-grid { text-align: left; grid-template-columns: 1fr; }
        }
      `}</style>

            <div
                id='lightbox'
                className={lightboxImage ? 'open' : ''}
                onClick={() => setLightboxImage(null)}
                style={{ display: lightboxImage ? 'flex' : 'none' }}
            >
                {lightboxImage && <img src={lightboxImage} alt='Image zoom' />}
            </div>

            {isYandexPopupOpen && (
                <div className='yandex-popup' onClick={() => setIsYandexPopupOpen(false)}>
                    <div className='yandex-popup-modal' onClick={e => e.stopPropagation()}>
                        <button
                            type='button'
                            className='yandex-popup-close'
                            aria-label='Закрыть форму'
                            onClick={() => setIsYandexPopupOpen(false)}
                        >
                            ×
                        </button>
                        <iframe
                            src='https://forms.yandex.ru/u/6900b1c349af473065e763a2?iframe=1'
                            frameBorder='0'
                            name='ya-form-6900b1c349af473065e763a2'
                            title='Форма заявки Pixorion'
                        ></iframe>
                    </div>
                </div>
            )}

            <header className='header'>
                <a
                    href='https://pixorion.ai'
                    className='logo-link'
                    style={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                >
                    <img
                        src='/assets/favicon/apple-touch-icon.png'
                        alt='Pixorion.AI'
                        style={{ height: '24px', width: '24px' }}
                    />
                    <Logo className='logo-header' />
                </a>
                <nav className={`nav ${menuOpen ? 'open' : ''}`}>
                    <a href='#features'>Возможности</a>
                    <a href='#pricing'>Тарифы</a>
                    <a href='#faq'>FAQ</a>
                </nav>
                <div className='header-right'>
                    <a href='/app/' className='btn-primary'>
                        Войти
                    </a>
                    <button className='menu-btn' onClick={() => setMenuOpen(!menuOpen)}>
                        <svg
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                        >
                            <line x1='4' y1='6' x2='20' y2='6' />
                            <line x1='4' y1='12' x2='20' y2='12' />
                            <line x1='4' y1='18' x2='20' y2='18' />
                        </svg>
                    </button>
                </div>
            </header>

            <section className='hero'>
                <div className='hero-bg'></div>
                <div className='hero-inner'>
                    <div>
                        <div className='hero-badge'>
                            <svg width='14' height='14' viewBox='0 0 24 24' fill='currentColor'>
                                <path d='M12 3l1.9 5.8L20 11l-6.1 2.2L12 19l-1.9-5.8L4 11l6.1-2.2L12 3z' />
                            </svg>
                            ИИ-система для продавцов на маркетплейсах
                        </div>
                        <h1>
                            Превращайте карточки
                            <br />
                            <span style={{ whiteSpace: 'nowrap' }}>
                                в <span className='shimmer'>МАГНИТ</span>
                            </span>{' '}
                            для покупателей
                        </h1>
                    </div>
                    <div className='benefits'>
                        {BENEFITS.map((benefit, i) => (
                            <div key={i} className={`benefit ${activeBenefit === i ? 'active' : ''}`}>
                                <span>{benefit}</span>
                            </div>
                        ))}
                        <div className='benefit-dots'>
                            {BENEFITS.map((_, i) => (
                                <button
                                    key={i}
                                    className={activeBenefit === i ? 'active' : ''}
                                    onClick={() => setActiveBenefit(i)}
                                />
                            ))}
                        </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                        <a href='/app/' className='cta-main'>
                            Попробовать бесплатно{' '}
                            <svg
                                width='20'
                                height='20'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                strokeWidth='2'
                            >
                                <line x1='5' y1='12' x2='19' y2='12' />
                                <polyline points='12 5 19 12 12 19' />
                            </svg>
                        </a>
                        <p className='cta-sub'>
                            <svg
                                width='16'
                                height='16'
                                viewBox='0 0 24 24'
                                fill='currentColor'
                                style={{ color: '#be96ff' }}
                            >
                                <polygon points='13 2 3 14 12 14 11 22 21 10 12 10 13 2' />
                            </svg>
                            <strong>250 токенов</strong> уже ждут вас
                        </p>
                    </div>
                </div>
            </section>

            <section className='section'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Результаты работы Pixorion.ai</h2>
                        <p>Три инструмента — один сервис</p>
                    </div>
                    <div
                        ref={showcaseTabsRef}
                        className='showcase-tabs'
                        onClick={handleShowcaseInteraction}
                        onMouseEnter={handleShowcaseInteraction}
                        onMouseLeave={handleShowcaseMouseLeave}
                    >
                        {['audit', 'images', 'text'].map(tab => (
                            <button
                                key={tab}
                                className={`tab ${activeTab === tab ? 'active' : ''}`}
                                onClick={() => setActiveTab(tab)}
                            >
                                {tab === 'audit'
                                    ? 'Аудит карточки'
                                    : tab === 'images'
                                      ? 'Генерация изображений'
                                      : 'Генерация текста'}
                            </button>
                        ))}
                    </div>
                    <div
                        ref={showcasePanelRef}
                        className='showcase-panel'
                        onClick={handleShowcaseInteraction}
                        onMouseEnter={handleShowcaseInteraction}
                        onMouseLeave={handleShowcaseMouseLeave}
                    >
                        {activeTab === 'images' && (
                            <div className='subtabs'>
                                {['shirt', 'shampoo', 'case'].map(sub => (
                                    <button
                                        key={sub}
                                        className={`subtab ${activeSub === sub ? 'active' : ''}`}
                                        onClick={() => setActiveSub(sub)}
                                    >
                                        {sub === 'shirt' ? 'Футболка' : sub === 'shampoo' ? 'Шампунь' : 'Чехол'}
                                    </button>
                                ))}
                            </div>
                        )}
                        <div className='product-grid'>
                            {displayedImages.map((img, i) => (
                                <img
                                    key={i}
                                    src={img}
                                    alt={`Product ${i + 1}`}
                                    onClick={() => {
                                        setIsTabRotationPaused(true)
                                        setLightboxImage(img)
                                    }}
                                />
                            ))}
                        </div>
                        <p className='showcase-caption'>{captions[activeTab as keyof typeof captions]}</p>
                    </div>
                </div>
            </section>

            <section className='section' id='features'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Что мы предлагаем</h2>
                        <p>Полный цикл работы с карточками товаров</p>
                    </div>
                    <div className='features-grid'>
                        {[
                            {
                                icon: 'audit',
                                title: 'Аудит карточки',
                                sub: 'Проверка и анализ',
                                items: [
                                    'Ошибки с приоритетами по важности',
                                    'Рекомендации с примерами для каждого элемента',
                                    'Прямая загрузка карточек из Wildberries и OZON',
                                ],
                            },
                            {
                                icon: 'images',
                                title: 'Генерация изображений',
                                sub: 'Обработка и подача контента',
                                items: [
                                    'Чёткая передача фактуры и деталей товара на фото',
                                    'Генерация оптимального комплекта изображений',
                                    'Точная настройка стиля под стандарты бренда',
                                ],
                            },
                            {
                                icon: 'text',
                                title: 'SEO-копирайтинг',
                                sub: 'Создание названий и описаний',
                                items: [
                                    'Продающие тексты в рамках требований площадок',
                                    'Ключевики без переспама и переоптимизации',
                                    'Отдельные версии описаний для WB, OZON и других',
                                ],
                            },
                        ].map((feature, i) => (
                            <div key={i} className='feature-card'>
                                <div className='feature-icon'>
                                    {feature.icon === 'audit' ? (
                                        <svg
                                            width='28'
                                            height='28'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='white'
                                            strokeWidth='1.5'
                                        >
                                            <rect x='3' y='3' width='18' height='18' rx='3' />
                                            <path
                                                d='M7 14v3M11 11v6M15 8v9M19 5l-4 4'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                        </svg>
                                    ) : feature.icon === 'images' ? (
                                        <svg
                                            width='28'
                                            height='28'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='white'
                                            strokeWidth='1.5'
                                        >
                                            <rect x='3' y='5' width='18' height='14' rx='2' />
                                            <circle cx='8' cy='10' r='2' />
                                            <path
                                                d='M21 19l-5-5-3 3-4-4-6 6'
                                                strokeLinecap='round'
                                                strokeLinejoin='round'
                                            />
                                            <path d='M17 3v4M19 5h-4' strokeLinecap='round' />
                                        </svg>
                                    ) : (
                                        <svg
                                            width='28'
                                            height='28'
                                            viewBox='0 0 24 24'
                                            fill='none'
                                            stroke='white'
                                            strokeWidth='1.5'
                                        >
                                            <rect x='4' y='2' width='16' height='20' rx='2' />
                                            <line x1='8' y1='7' x2='16' y2='7' />
                                            <line x1='8' y1='11' x2='16' y2='11' />
                                            <line x1='8' y1='15' x2='12' y2='15' />
                                        </svg>
                                    )}
                                </div>
                                <h3>{feature.title}</h3>
                                <p className='sub'>{feature.sub}</p>
                                <ul>
                                    {feature.items.map((item, j) => (
                                        <li key={j}>
                                            <span
                                                style={{
                                                    display: 'inline-block',
                                                    width: '6px',
                                                    height: '6px',
                                                    borderRadius: '50%',
                                                    background: '#a855f7',
                                                    flexShrink: 0,
                                                }}
                                            ></span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='section'>
                <div className='container'>
                    <div className='cta-banner'>
                        <h2>Плохие карточки тормозят продажи?</h2>
                        <p>Выбирайте Pixorion.AI — дарим 250 токенов при регистрации</p>
                        <a href='/app/' className='btn'>
                            Попробовать сейчас{' '}
                            <svg
                                width='18'
                                height='18'
                                viewBox='0 0 24 24'
                                fill='none'
                                stroke='currentColor'
                                strokeWidth='2'
                            >
                                <line x1='5' y1='12' x2='19' y2='12' />
                                <polyline points='12 5 19 12 12 19' />
                            </svg>
                        </a>
                    </div>
                </div>
            </section>

            <section className='section'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Почему Pixorion.ai</h2>
                        <p>Мы автоматизируем рутину</p>
                    </div>
                    <div className='whyus-grid'>
                        <div className='whyus-card minus'>
                            <h4>Без Pixorion</h4>
                            <ul>
                                {[
                                    'Найм дорогостоящих дизайнеров',
                                    'Написание промптов',
                                    'Нестабильная генерация изображений',
                                    'Медленная поверхностная аналитика',
                                    'Общие рекомендации без контекста',
                                    'Зарубежные сервисы и риски',
                                ].map((item, i) => (
                                    <li key={i}>
                                        <span className='item-icon'>✕</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                        <div className='whyus-card plus'>
                            <h4>С Pixorion</h4>
                            <ul>
                                {[
                                    'Все инструменты в одном окне',
                                    'Минимальные затраты на контент',
                                    'Точная генерация в один клик',
                                    'Аналитика 50+ параметров за минуту',
                                    'Бенчмарки маркетплейсов РФ',
                                    'Российский сервис с безопасной оплатой',
                                ].map((item, i) => (
                                    <li key={i}>
                                        <span className='item-icon'>✓</span>
                                        {item}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </section>

            <section className='section'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Для тех, кто хочет продавать больше</h2>
                    </div>
                    <div className='forwhom-grid'>
                        {[
                            {
                                icon: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="16" cy="10" r="4" fill="currentColor"/><path d="M6 26c0-4.5 4-8 10-8s10 3.5 10 8v1H6v-1z" fill="currentColor"/><path d="M25 4l0.7 2L28 7l-2.3 1L25 10l-0.7-2L22 7l2.3-1L25 4z" fill="currentColor" opacity="0.9"/></svg>',
                                title: 'Селлеры',
                                desc: 'Интуитивный интерфейс, впечатляющий результат без помощи дизайнеров',
                            },
                            {
                                icon: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="3.5" fill="currentColor"/><circle cx="21" cy="11" r="3.5" fill="currentColor"/><path d="M4 24c0-3.5 3-6 7-6s7 2.5 7 6v2H4v-2z" fill="currentColor"/><path d="M18 21.5c1.5-2 4-3.5 7-3.5s6 2 6 5v2.5H19.5c-0.5-1.5-1-3-1.5-4z" fill="currentColor"/><path d="M27 6l0.5 1.4 1.5 0.6-1.5 0.6L27 10l-0.5-1.4L25 8l1.5-0.6L27 6z" fill="currentColor" opacity="0.9"/></svg>',
                                title: 'Агентства',
                                desc: 'Внедрение лучших практик, тестирование гипотез, повышение конверсии',
                            },
                            {
                                icon: '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 14v12h20V14H6z" fill="currentColor" opacity="0.92"/><path d="M4 12l4-6h16l4 6H4z" fill="currentColor"/><rect x="13" y="18" width="6" height="8" rx="0.5" fill="#7641e2" fill-opacity="0.5"/><rect x="8" y="16.5" width="3" height="2.5" fill="#7641e2" fill-opacity="0.4"/><rect x="21" y="16.5" width="3" height="2.5" fill="#7641e2" fill-opacity="0.4"/><path d="M16 2l0.7 1.8L18.5 4.5l-1.8 0.7L16 7l-0.7-1.8L13.5 4.5l1.8-0.7L16 2z" fill="currentColor" opacity="0.95"/></svg>',
                                title: 'Бренды',
                                desc: 'Продвинутая аналитика, автоматизация и пакетная обработка',
                            },
                        ].map((card, i) => (
                            <div key={i} className='forwhom-card'>
                                <div className='ico' dangerouslySetInnerHTML={{ __html: card.icon }} />
                                <h3>{card.title}</h3>
                                <p>{card.desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='section' id='pricing'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Варианты использования</h2>
                    </div>
                    <div className='pricing-grid'>
                        {[
                            {
                                title: 'Пробный период',
                                sub: 'Для новых пользователей',
                                price: 'Бесплатно',
                                items: [
                                    '250 токенов при регистрации',
                                    'Хватит на ~10 генераций',
                                    'Далее подписка или пакеты от 2 000 ₽',
                                ],
                                btn: 'Начать бесплатно',
                            },
                            {
                                title: 'Подписка',
                                sub: 'Для активных продавцов',
                                price: '5 999',
                                suf: '₽/мес',
                                items: ['1700 токенов', 'Хватит на ~65 генераций', 'На 30 дней'],
                                btn: 'Подключить подписку',
                                href: 'https://pixorion.ai/app/profile/payment',
                                badge: 'Рекомендуем',
                                featured: true,
                            },
                            {
                                title: 'Индивидуальный',
                                sub: 'Для ваших задач',
                                price: 'По запросу',
                                items: [
                                    'Неограниченные возможности',
                                    'Персональная поддержка',
                                    'Индивидуальные тарифы',
                                ],
                                btn: 'Оставить заявку',
                                href: '#subscribe',
                            },
                        ].map((plan: PricingPlan, i) => (
                            <div key={i} className={`price-card ${plan.featured ? 'featured' : ''}`}>
                                {plan.badge && <div className='price-badge'>{plan.badge}</div>}
                                <h3>{plan.title}</h3>
                                <p className='plan-sub'>{plan.sub}</p>
                                <div className='price-value'>
                                    <span className='num'>{plan.price}</span>
                                    {plan.suf && <span className='suf'>{plan.suf}</span>}
                                </div>
                                <ul>
                                    {plan.items.map((item: string, j: number) => (
                                        <li key={j}>
                                            <span className='check-ico'>✓</span>
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                                {plan.href === '#subscribe' ? (
                                    <button
                                        type='button'
                                        className='price-btn'
                                        onClick={() => setIsYandexPopupOpen(true)}
                                    >
                                        {plan.btn}
                                    </button>
                                ) : (
                                    <a href={plan.href ?? '/app/'} className='price-btn'>
                                        {plan.btn}
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div id='subscribe' className='mb-20'></div>

            <section className='section'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>СМИ о Pixorion.ai</h2>
                    </div>
                    <div className='media-grid'>
                        <a
                            href='https://incrussia.ru/news/rossijskaya-ii-platforma-dlya-prodazh-na-marketplejsah-privlekla-pervye-investitsii/'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='media-card'
                        >
                            <div
                                className='media-logo'
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src='/assets/images/logo-incru-new.svg'
                                    alt='Inc.ru'
                                    style={{ maxWidth: '70px', maxHeight: '24px' }}
                                />
                            </div>
                            <p>Российская ИИ-платформа для продаж на маркетплейсах привлекла первые инвестиции</p>
                            <span className='media-link'>Подробнее ↗</span>
                        </a>
                        <a
                            href='https://www.cnews.ru/news/line/2025-11-27_venchurnyj_fond_iskra_ventures_investiruet'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='media-card'
                        >
                            <div
                                className='media-logo'
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src='/assets/images/logo-cnews.svg'
                                    alt='CNews'
                                    style={{ maxWidth: '90px', maxHeight: '24px' }}
                                />
                            </div>
                            <p>Венчурный фонд Iskra Ventures инвестирует в ИИ-платформу Pixorion.ai</p>
                            <span className='media-link'>Подробнее ↗</span>
                        </a>
                        <a
                            href='https://www.forbes.ru/svoi-biznes/550938-subbotnij-vencur-12-mln-v-proekt-brat-ev-libermanov-i-novyj-fond-amur-kapital'
                            target='_blank'
                            rel='noopener noreferrer'
                            className='media-card'
                        >
                            <div
                                className='media-logo'
                                style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    padding: '12px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                            >
                                <img
                                    src='/assets/images/logo-forbes.png'
                                    alt='Forbes'
                                    style={{ maxWidth: '90px', maxHeight: '24px' }}
                                />
                            </div>
                            <p>Субботний венчур — 12 млн в проект и новый фонд</p>
                            <span className='media-link'>Подробнее ↗</span>
                        </a>
                    </div>
                </div>
            </section>

            <section className='section' id='faq'>
                <div className='container'>
                    <div className='section-head'>
                        <h2>Часто задаваемые вопросы</h2>
                        <p>
                            Не нашли ответ?{' '}
                            <a href='mailto:support@pixorion.ai' style={{ color: '#a855f7' }}>
                                support@pixorion.ai
                            </a>
                        </p>
                    </div>
                    <div className='faq-wrap'>
                        {FAQS.map((item, i) => (
                            <div key={i} className={`faq-item ${openFaq === i ? 'open' : ''}`}>
                                <button className='faq-q' onClick={() => setOpenFaq(openFaq === i ? null : i)}>
                                    {item.q}
                                    <svg
                                        className='chev'
                                        viewBox='0 0 24 24'
                                        fill='none'
                                        stroke='currentColor'
                                        strokeWidth='2'
                                    >
                                        <polyline points='6 9 12 15 18 9' />
                                    </svg>
                                </button>
                                <div className='faq-a'>{item.a}</div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className='section'>
                <div className='final-cta'>
                    <span className='spark'>✨</span>
                    <h2>Начните отличаться от конкурентов!</h2>
                    <p>Дарим 250 токенов при регистрации</p>
                    <a href='/app/' className='cta-main'>
                        Попробовать Pixorion.AI{' '}
                        <svg
                            width='18'
                            height='18'
                            viewBox='0 0 24 24'
                            fill='none'
                            stroke='currentColor'
                            strokeWidth='2'
                        >
                            <line x1='5' y1='12' x2='19' y2='12' />
                            <polyline points='12 5 19 12 12 19' />
                        </svg>
                    </a>
                </div>
            </section>

            <footer>
                <div className='container'>
                    <div className='footer-grid'>
                        <div className='footer-col'>
                            <a
                                href='https://pixorion.ai'
                                style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    marginBottom: '16px',
                                    color: 'white',
                                    textDecoration: 'none',
                                }}
                            >
                                <img
                                    src='/assets/favicon/apple-touch-icon.png'
                                    alt='Pixorion.AI'
                                    style={{ height: '32px', width: '32px' }}
                                />
                                <Logo className='logo-footer' />
                            </a>
                            <p>ИИ-система для продавцов на маркетплейсах</p>
                        </div>
                        <div className='footer-col'>
                            <h5>Продукт</h5>
                            <a href='#features'>Возможности</a>
                            <a href='#pricing'>Тарифы</a>
                            <a href='#faq'>FAQ</a>
                            <a href='/app/'>Войти</a>
                        </div>
                        <div className='footer-col'>
                            <h5>Документы</h5>
                            <a href='https://pixorion.ai/privacy.pdf' target='_blank' rel='noopener noreferrer'>
                                Политика конфиденциальности
                            </a>
                            <a href='https://pixorion.ai/eula.pdf' target='_blank' rel='noopener noreferrer'>
                                Оферта
                            </a>
                        </div>
                        <div className='footer-col'>
                            <h5>Контакты</h5>
                            <a href='mailto:support@pixorion.ai'>support@pixorion.ai</a>
                            <a href='https://t.me/pixorionai' target='_blank' rel='noopener noreferrer'>
                                Telegram
                            </a>
                        </div>
                    </div>
                    <div className='footer-bottom'>
                        <nav>
                            <a href='https://pixorion.ai/privacy.pdf' target='_blank' rel='noopener noreferrer'>
                                Политика конфиденциальности
                            </a>
                            <a href='https://pixorion.ai/eula.pdf' target='_blank' rel='noopener noreferrer'>
                                Оферта
                            </a>
                        </nav>
                        <p className='copy'>© 2025-2026 Pixorion.AI. Все права защищены.</p>
                    </div>
                </div>
            </footer>

            <CookieConsent />
        </div>
    )
}

export default Landing
